// Utility helpers to normalize player/connection identifiers.
// Prefer persistent userId, fallback to socketId, then generic id.
export function pidOf(player) {
  if (!player) return null;
  if (typeof player === "string" || typeof player === "number") return player;
  return player.userId || player.socketId || player.id || null;
}

// Compute current client's canonical id: prefer authenticated userId, then socket id.
export function currentClientId(socket, user) {
  return (user && user.userId) || (socket && socket.auth && socket.auth.userId) || (socket && socket.id) || null;
}

export function isLocalPlayerId(targetPlayerId, players, socket, user) {
  if (!targetPlayerId) return false;
  if (user && user.socketId && user.socketId === targetPlayerId) return true;
  if (user && user.userId && user.userId === targetPlayerId) return true;
  if (socket && socket.id && socket.id === targetPlayerId) return true;
  if (socket && socket.auth && socket.auth.userId && socket.auth.userId === targetPlayerId) return true;

  const matchedPlayer = Array.isArray(players)
    ? players.find(
        (player) =>
          player?.socketId === targetPlayerId ||
          player?.userId === targetPlayerId ||
          player?.id === targetPlayerId
      )
    : null;

  if (!matchedPlayer) return false;
  if (user && user.userId && matchedPlayer.userId === user.userId) return true;
  if (user && user.socketId && matchedPlayer.socketId === user.socketId) return true;
  if (socket && socket.id && matchedPlayer.socketId === socket.id) return true;

  return false;
}

const NormalizePlayerId = { pidOf, currentClientId, isLocalPlayerId };
export default NormalizePlayerId;
